<template>
  <div class="addcost-container">
    <div class="dialog-main add-dialog">
      <el-form label-position="right" label-width="120px" :rules="rules" ref="addForm" :model="addForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="费用(元)：" prop="fee">
              <el-input v-model="addForm.fee"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产生日期：" prop="feeDate">
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="addForm.feeDate"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="费用类型：" prop="feeType">
              <el-select v-model="addForm.feeType">
                <el-option
                  v-for="item in compactPayType.results"
                  :key="item.uid"
                  :label="item.name"
                  :value="item.uid">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收款方：" prop="payee">
              <el-input v-model="addForm.payee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：" prop="remarks">
              <el-input
                type="textarea"
                placeholder="不超过200字"
                :rows="4"
                v-model="addForm.remarks"
                name="remarks">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
        <crm-button :buttonType="'plain'" :text="'取消'" @click="handleClose"></crm-button>
        <crm-button :text="'确定'" :disabled="isSubmitDisabled" @click="handleSave"></crm-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CrmButton from '~component/base/crmButton';

export default {
  components: {
    CrmButton,
  },
  props: {
    compactId: {
      type: String,
    },
    type: String,
    payDetail: Object,
  },
  data() {
    const totalMoneyRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入费用'));
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error('请输入最多两位小数且无逗号的数字'));
      } else if (value > 9999999.99) {
        callback(new Error('最大9999999.99'));
      } else {
        callback();
      }
    };
    return {
      addForm: {},
      rules: {
        fee: [
          { required: true, validator: totalMoneyRule, trigger: 'blur' },
        ],
        feeDate: [
          { required: true, message: '请选择产生日期', trigger: 'change' },
        ],
        feeType: [
          { required: true, message: '请选择费用类型', trigger: 'change' },
        ],
        payee: [
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        remarks: [
          { max: 200, message: '不超过200个字', trigger: 'blur' },
        ],
      },
      isSubmitDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      compactPayType: 'compact/compactPayType',
    }),
  },
  created() {
    this.initAddForm();
    this.getPayType({
      code: 'category_fee_type',
    });
  },
  methods: {
    ...mapActions({
      getPayType: 'compact/getPayType',
      saveAddCompactFee: 'compact/saveAddCompactFee',
      saveUpdateCompactFee: 'compact/saveUpdateCompactFee',
    }),
    initAddForm() {
      if (this.type === 'edit') {
        this.addForm = {
          id: this.payDetail.id,
          fee: this.payDetail.fee,
          feeDate: this.payDetail.feeDate,
          feeType: this.payDetail.feeType,
          payee: this.payDetail.payee,
          remarks: this.payDetail.remarks,
        };
      } else {
        this.addForm = {
          fee: null,
          feeDate: '',
          feeType: '',
          payee: '',
          remarks: '',
        };
      }
    },
    handleClearForm() {
      this.addForm = {
        fee: null,
        feeDate: '',
        feeType: '',
        payee: '',
        remarks: '',
      };
    },
    handleClose() {
      this.$emit('close');
      this.handleClearForm();
    },
    handleSave() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.isSubmitDisabled = true;
          if (this.type === 'edit') {
            this.saveUpdateCompactFee({
              ...this.addForm,
            }).then(() => {
              this.$message({
                type: 'success',
                message: '编辑费用成功',
              });
              this.$emit('close');
              this.$emit('success');
              this.handleClearForm();
            }).finally(() => {
              this.isSubmitDisabled = false;
            });
          } else {
            this.saveAddCompactFee({
              contractId: this.compactId,
              ...this.addForm,
            }).then(() => {
              this.$message({
                type: 'success',
                message: '新增费用成功',
              });
              this.$emit('close');
              this.$emit('success');
              this.handleClearForm();
            }).finally(() => {
              this.isSubmitDisabled = false;
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less">
.addcost-container {
  padding-right: 30px;
  .dialog-footer{
    text-align: right;
  }
  .el-date-editor.el-input{
    width: 100%;
  }
}
</style>
